import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import momRatings from "../../../../src/data/articles/cube-prospective-march-of-the-machine/mom-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  momRatings,
  ProspectiveIntro,
  React
};